import React, { FC } from 'react';

import { Box, Grid } from '@mui/material';

import { PaymentPlans, PharmacyBillingPageStatuses } from '@pharmaplan/common';

import PlanBlock from '../GetPayment/PaymentPlanBlock/PlanBlock';
import CustomTableBack from '../../../../common/CustomTableBack';
import strings from '../../../../../localization';
import SavedCard from '../ExistingPaymentPlan/SavedPlanDetails/SavedCard';

import UpgradePlanButton from './UpgradePlanButton';
import styles from './styles';

interface IUpgradePlan {
  setPageStatus: React.Dispatch<
    React.SetStateAction<PharmacyBillingPageStatuses>
  >;
}

const UpgradePlan: FC<IUpgradePlan> = ({ setPageStatus }) => {
  const back = () => {
    setPageStatus(PharmacyBillingPageStatuses.existingPaymentPlan);
  };

  return (
    <>
      <CustomTableBack onClick={back} backLabel={strings.back} />
      <Grid columnGap={3} container>
        <Grid xs={12} md={5} item>
          <PlanBlock planType={PaymentPlans.unlimited} showRadio={false} />
        </Grid>

        <Grid xs={12} md={6} sx={styles.upgradeCardContainer} item>
          <Box>
            <SavedCard />
            <UpgradePlanButton setPageStatus={setPageStatus} />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default UpgradePlan;
